import { Truck, CheckCircle2, AlertTriangle, PackageX, Loader2 } from "lucide-react";

const QUICK = [
  ["MARG_OK", "Marg OK", CheckCircle2, "border-emerald-400 bg-emerald-50 text-emerald-800 active:bg-emerald-100"],
  ["DAMAGE", "Damage", AlertTriangle, "border-amber-400 bg-amber-50 text-amber-800 active:bg-amber-100"],
  ["EMPTY_PARCEL", "Empty", PackageX, "border-rose-300 bg-rose-50 text-rose-700 active:bg-rose-100"],
];

const Field = ({ k, v, mono }) => (
  <div className="min-w-0"><span className="text-slate-400">{k} </span>
    <span className={`font-medium text-slate-700 break-all ${mono ? "font-mono" : ""}`}>{v || "—"}</span></div>
);

// Phone view of Returned Parcels: one card per parcel with quick archive buttons (voucher # asked like PC).
export const RpMobileCards = ({ rows, loading, statusLabel, onArchive, onReship }) => (
  <div className="md:hidden space-y-2" data-testid="rp-cards">
    {loading && !rows.length && <p className="py-6 text-center text-sm text-slate-500"><Loader2 className="inline w-4 h-4 animate-spin mr-1" />Loading…</p>}
    {!loading && !rows.length && <p className="py-6 text-center text-sm text-slate-500" data-testid="rp-cards-empty">No returned parcels.</p>}
    {rows.map((r, i) => (
      <div key={r.id} className="rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-[11px]" data-testid={`rp-card-${i}`}>
        <div className="flex items-start gap-2">
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold text-slate-900 break-words">{r.customer_name || "—"}</div>
            <div className="text-slate-500 break-all">{r.client_code || "—"} · returned {r.return_date || "—"}</div>
          </div>
          <div className="flex flex-wrap justify-end gap-1 shrink-0 max-w-[45%]">
            {r.service && <span className="rounded bg-indigo-50 px-1.5 py-0.5 text-[10px] font-semibold text-indigo-700">{r.service}</span>}
            <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-700" data-testid={`rp-card-status-${i}`}>{statusLabel(r)}</span>
          </div>
        </div>
        <div className="mt-1.5 grid grid-cols-2 gap-x-3 gap-y-0.5">
          <div className="col-span-2"><Field k="Tracking" v={r.tracking} mono /></div>
          <Field k="Invoice" v={r.invoice_no} />
          <Field k="Inv. date" v={(r.shipping_date || "").split("T")[0]} />
          <Field k="Country" v={r.destination_country} />
          <Field k="Billed to" v={r.billed_to} />
          {r.value_usd != null && <Field k="Value" v={`₹${Number(r.value_inr).toFixed(2)} / $${Number(r.value_usd).toFixed(2)}`} />}
          {r.return_reason && <div className="col-span-2 text-rose-700">Reason: {r.return_reason}</div>}
          {r.remarks && <div className="col-span-2 text-slate-600 break-words">Remarks: {r.remarks}</div>}
        </div>
        <div className="mt-1 border-t border-slate-100 pt-1 space-y-0.5" data-testid={`rp-card-products-${i}`}>
          {(r.products?.length ? r.products : [{ name: "—", qty: r.total_qty || 0 }]).map((p, k) => (
            <div key={k} className="flex gap-2 text-slate-700">
              <span className="flex-1 min-w-0 break-words">{p.name}{p.batch ? <span className="text-slate-400"> · {p.batch}</span> : null}{p.exp ? <span className="text-slate-400"> · exp {p.exp}</span> : null}</span>
              <span className="font-bold">×{p.qty || 0}</span>
            </div>))}
        </div>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {QUICK.map(([st, label, Icon, tone]) => (
            <button key={st} type="button" onClick={() => onArchive(r, st)} data-testid={`rp-card-${st.toLowerCase()}-${i}`}
              className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 font-semibold ${tone}`}>
              <Icon className="w-3.5 h-3.5" /> {label}</button>))}
          <button type="button" onClick={() => onReship(r)} data-testid={`rp-card-reship-${i}`}
            className="ml-auto inline-flex items-center gap-1 rounded-full border border-slate-300 px-2.5 py-1 font-semibold text-slate-700 active:bg-slate-50">
            <Truck className="w-3.5 h-3.5" /> Reship</button>
        </div>
      </div>
    ))}
  </div>
);
